import { Box } from '@mui/material'
import { MainTabComponent } from './components'

export const HomeModule = () => {
  return (
    <Box
      p={2}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      <MainTabComponent />
    </Box>
  )
}
